import axios from 'axios';
import { userApi } from "../../config";

const baseUrl = process.env.REACT_APP_API_BASE_URL || "http://localhost:5001";
const publicApi = axios.create({
    baseURL: `${baseUrl}/user/api/v1`,
});


export const fetchClassesData = async () => {
    try {
        const res = await userApi.get("/fetch-all-classes");
        return res.data;
    } catch (err) {
        return { "message": "Something went wrong! Try Again." }
    }
}

interface fetchApi {
    data: object;
}

export const fetchClassDetails = async (classId: string) => {
    try {
        if (!classId) { // Add this check
            throw new Error("Class ID is empty or invalid.");
        }

        const userToken = sessionStorage.getItem("userAccessToken");
        const mentorToken = sessionStorage.getItem("mentorAccessToken");
        const token = userToken || mentorToken || null;

        const res = await publicApi.get<fetchApi>(`/fetch-class-details`, {
            params: { classId: classId }, // Send classId as query parameter
            headers: { "Authorization": `Bearer ${token}` }
        });
        return res.data?.data;
    } catch (err: any) { // Explicitly type err as any to access message
        console.error("Error fetching class details:", err);
        // Return a more specific error message if it's an AxiosError
        if (err && err.response?.data?.message) { // Use isAxiosError here
            return { "message": err.response.data.message };
        }
        return { "message": "Something went wrong! Try Again." }
    }
}

export const bookClass = async (bookingData: any) => {
    try {
        const token = sessionStorage.getItem("userAccessToken") || sessionStorage.getItem("mentorAccessToken") || null;
        const res = await userApi.post("/book-class", bookingData, { headers: { Authorization: `Bearer ${token}` } });
        return res.data;
    } catch (err: any) {
        return { "message": err.response?.data?.message || err.message };
    }
};

export const verifyPaymentAPI = async (paymentData: any) => {
    try {
        const token = sessionStorage.getItem("userAccessToken") || sessionStorage.getItem("mentorAccessToken") || null;
        const res = await userApi.post("/verify-payment", paymentData, { headers: { Authorization: `Bearer ${token}` } });
        return res.data;
    } catch (err: any) {
        return { success: false, message: err.response?.data?.message || "Payment verification failed." };
    }
};

export const completeDemoAPI = async (bookingId: string) => {
    try {
        const token = sessionStorage.getItem("userAccessToken") || sessionStorage.getItem("mentorAccessToken") || null;
        const res = await userApi.post("/complete-demo", { bookingId }, { headers: { Authorization: `Bearer ${token}` } });
        return res.data;
    } catch (err: any) {
        return { success: false, message: err.response?.data?.message || "Failed to complete demo." };
    }
};

export const cancelBookingAPI = async (bookingId: string) => {
    try {
        const token = sessionStorage.getItem("userAccessToken") || sessionStorage.getItem("mentorAccessToken") || null;
        const res = await userApi.post("/cancel-booking", { bookingId }, { headers: { Authorization: `Bearer ${token}` } });
        return res.data;
    } catch (err: any) {
        return { success: false, message: err.response?.data?.message || "Failed to cancel booking." };
    }
};
